// GENERATED by scripts/gen-plugin-descriptors.ts - DO NOT EDIT.
// Source of truth: packages/ecosystem-catalog/plugins/<id>/okra-plugin.jsonc
// Re-generate: pnpm --filter @okrapdf/ecosystem-catalog gen:descriptors
import type { CatalogPluginDescriptor } from './descriptors.ts';

export const pluginDescriptors = [
  {
    "id": "gemini-flash",
    "version": "0.1.0",
    "kind": "parser",
    "runtime": "in_process",
    "format": "native",
    "trust": "trusted",
    "name": "Gemini Flash",
    "description": "Default in-worker Google Gemini Flash parser. Sends PDF pages to Google Gemini using this Worker's GOOGLE_API_KEY secret and can read scanned or image-heavy pages; egress is pinned to Google's Gemini API host.",
    "catalog": {
      "one_liner": "In-worker Google Gemini parser for scanned and image-heavy PDFs with normalized okra blocks.",
      "npm_package": "@okrapdf/parser-gemini",
      "package_path": "packages/parser-gemini"
    },
    "category": "parse-extract",
    "tags": [
      "ocr",
      "vlm"
    ],
    "publisher": "okrapdf",
    "license": "MIT",
    "homepage": "https://ai.google.dev/gemini-api/docs",
    "capabilities": [
      "network:fetch"
    ],
    "allowed_hosts": [
      "generativelanguage.googleapis.com"
    ],
    "adapter": {
      "type": "gemini_flash"
    }
  },
  {
    "id": "gmail",
    "version": "0.1.0",
    "kind": "source",
    "runtime": "http_base_url",
    "format": "sandboxed",
    "trust": "external",
    "name": "Gmail",
    "description": "Import PDF attachments from Gmail into okra and run parse → extract → verify.",
    "category": "sources",
    "publisher": "okrapdf",
    "license": "MIT",
    "capabilities": [
      "network:fetch",
      "source:list",
      "source:fetch"
    ],
    "allowed_hosts": [
      "gmail.googleapis.com",
      "googleapis.com",
      "oauth2.googleapis.com"
    ],
    "config_schema": {
      "refreshToken": {
        "type": "string",
        "secret": true,
        "required": true,
        "label": "Google OAuth refresh token"
      },
      "clientId": {
        "type": "string",
        "secret": true,
        "required": true,
        "label": "OAuth client ID"
      },
      "clientSecret": {
        "type": "string",
        "secret": true,
        "required": true,
        "label": "OAuth client secret"
      },
      "query": {
        "type": "string",
        "required": false,
        "label": "Gmail search query",
        "default": "has:attachment filename:pdf",
        "placeholder": "has:attachment filename:pdf"
      }
    },
    "adapter": {
      "type": "source",
      "provider": "gmail"
    }
  },
  {
    "id": "google-drive",
    "version": "0.1.0",
    "kind": "source",
    "runtime": "http_base_url",
    "format": "sandboxed",
    "trust": "external",
    "name": "Google Drive",
    "description": "Import PDFs from a Google Drive folder into okra and run parse → extract → verify.",
    "category": "sources",
    "publisher": "okrapdf",
    "license": "MIT",
    "capabilities": [
      "network:fetch",
      "source:list",
      "source:fetch"
    ],
    "allowed_hosts": [
      "googleapis.com",
      "www.googleapis.com",
      "oauth2.googleapis.com"
    ],
    "config_schema": {
      "refreshToken": {
        "type": "string",
        "secret": true,
        "required": true,
        "label": "Google OAuth refresh token"
      },
      "clientId": {
        "type": "string",
        "secret": true,
        "required": true,
        "label": "OAuth client ID"
      },
      "clientSecret": {
        "type": "string",
        "secret": true,
        "required": true,
        "label": "OAuth client secret"
      },
      "folderId": {
        "type": "string",
        "required": false,
        "label": "Drive folder ID (optional)"
      },
      "query": {
        "type": "string",
        "required": false,
        "label": "Drive query override",
        "placeholder": "mimeType='application/pdf'"
      }
    },
    "adapter": {
      "type": "source",
      "provider": "google_drive"
    }
  },
  {
    "id": "mistral-ocr",
    "version": "0.1.0",
    "kind": "parser",
    "runtime": "openai_compatible",
    "format": "sandboxed",
    "trust": "external",
    "name": "Mistral OCR",
    "description": "OpenRouter preset using Mistral OCR PDF mode. Works on scanned or image-only PDFs and returns OCR text as canonical okra blocks. Bring your own OpenRouter API key; egress is pinned to openrouter.ai.",
    "category": "parse-extract",
    "tags": [
      "ocr",
      "vlm"
    ],
    "publisher": "openrouter",
    "license": "proprietary",
    "homepage": "https://openrouter.ai/docs/guides/overview/multimodal/pdfs",
    "capabilities": [
      "network:fetch"
    ],
    "allowed_hosts": [
      "openrouter.ai"
    ],
    "config_schema": {
      "apiKey": {
        "type": "string",
        "secret": true,
        "required": true,
        "label": "OpenRouter API key",
        "placeholder": "sk-or-..."
      }
    },
    "adapter": {
      "type": "openai_compatible",
      "base_url": "https://openrouter.ai/api/v1",
      "model": "qwen/qwen3-vl-235b-a22b-instruct",
      "openrouter_pdf_mode": "mistral-ocr"
    }
  },
  {
    "id": "pdf-tools",
    "version": "0.1.0",
    "kind": "operation_pack",
    "runtime": "in_process",
    "format": "native",
    "trust": "trusted",
    "name": "PDF Tools",
    "description": "Trusted in-worker pdf-lib operation pack for deterministic PDF edits without network egress.",
    "category": "page-operations",
    "publisher": "okrapdf",
    "license": "MIT",
    "capabilities": [],
    "allowed_hosts": [],
    "operations": [
      {
        "id": "merge",
        "title": "Merge PDFs",
        "category": "page-operations",
        "description": "Merge multiple base64 PDFs in order with pdf-lib.",
        "input_schema": {
          "type": "object",
          "required": [
            "input"
          ],
          "properties": {
            "input": {
              "oneOf": [
                {
                  "type": "string",
                  "description": "First base64-encoded PDF."
                },
                {
                  "type": "array",
                  "items": {
                    "type": "string"
                  },
                  "description": "Base64-encoded PDFs to merge."
                }
              ]
            },
            "args": {
              "type": "object",
              "properties": {
                "pdfs": {
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                },
                "pdfBase64s": {
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                },
                "inputs": {
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                }
              }
            }
          }
        },
        "args_schema": {
          "type": "object",
          "properties": {
            "pdfs": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "pdfBase64s": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "inputs": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          }
        }
      },
      {
        "id": "split",
        "title": "Split PDF",
        "category": "page-operations",
        "description": "Split a PDF into single-page PDFs or explicit page ranges.",
        "input_schema": {
          "type": "object",
          "required": [
            "input"
          ],
          "properties": {
            "input": {
              "type": "string",
              "description": "Base64-encoded PDF."
            },
            "args": {
              "type": "object"
            }
          }
        },
        "args_schema": {
          "type": "object",
          "properties": {
            "pages": {
              "description": "\"all\", \"odd\", \"even\", \"1,3-5\", or [1, 3, 4, 5]."
            },
            "ranges": {
              "type": "array",
              "description": "Optional list of page selectors; each becomes one output PDF."
            }
          }
        }
      },
      {
        "id": "extract-pages",
        "title": "Extract Pages",
        "category": "page-operations",
        "description": "Keep, delete, or rearrange pages by writing a new PDF with the selected page order.",
        "input_schema": {
          "type": "object",
          "required": [
            "input"
          ],
          "properties": {
            "input": {
              "type": "string",
              "description": "Base64-encoded PDF."
            },
            "args": {
              "type": "object"
            }
          }
        },
        "args_schema": {
          "type": "object",
          "properties": {
            "pages": {
              "description": "Pages to keep, preserving order. Example: [3, 1, 2] or \"3,1-2\"."
            },
            "deletePages": {
              "description": "Pages to remove when pages is omitted. Example: \"2,4-5\"."
            }
          }
        }
      },
      {
        "id": "stamp",
        "title": "Stamp PDF",
        "category": "content-editing",
        "description": "Draw text stamps with per-page templates, coordinates, and opacity.",
        "input_schema": {
          "type": "object",
          "required": [
            "input"
          ],
          "properties": {
            "input": {
              "type": "string",
              "description": "Base64-encoded PDF."
            },
            "args": {
              "type": "object"
            }
          }
        },
        "args_schema": {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "description": "Text or template. Supports {n}, {page}, {total}, {date}."
            },
            "template": {
              "type": "string",
              "description": "Alias for text."
            },
            "pages": {
              "description": "\"all\", \"odd\", \"even\", a range string, or page number array."
            },
            "x": {
              "type": "number"
            },
            "y": {
              "type": "number"
            },
            "xByPage": {
              "type": "object",
              "description": "Object keyed by page number for dynamic x coordinates."
            },
            "yByPage": {
              "type": "object",
              "description": "Object keyed by page number for dynamic y coordinates."
            },
            "opacityByPage": {
              "type": "object",
              "description": "Object keyed by page number for dynamic opacity."
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "rotation": {
              "type": "number"
            },
            "fontSize": {
              "type": "number"
            },
            "color": {
              "description": "Hex string, RGB tuple, or {r,g,b} object."
            },
            "position": {
              "type": "string",
              "description": "top-left, top-center, top-right, bottom-left, bottom-center, bottom-right, or center."
            },
            "perPage": {
              "description": "Object keyed by page number or array of page overrides for text/x/y/opacity."
            },
            "stamps": {
              "type": "array",
              "description": "Multiple stamp definitions."
            },
            "date": {
              "type": "string"
            }
          }
        }
      },
      {
        "id": "watermark",
        "title": "Watermark PDF",
        "category": "security-redact",
        "description": "Draw single or repeated dynamic text watermarks across pages.",
        "input_schema": {
          "type": "object",
          "required": [
            "input"
          ],
          "properties": {
            "input": {
              "type": "string",
              "description": "Base64-encoded PDF."
            },
            "args": {
              "type": "object"
            }
          }
        },
        "args_schema": {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "description": "Text or template. Supports {n}, {page}, {total}, {date}."
            },
            "template": {
              "type": "string",
              "description": "Alias for text."
            },
            "pattern": {
              "enum": [
                "single",
                "repeat"
              ]
            },
            "pages": {
              "description": "\"all\", \"odd\", \"even\", a range string, or page number array."
            },
            "x": {
              "type": "number"
            },
            "y": {
              "type": "number"
            },
            "xByPage": {
              "type": "object"
            },
            "yByPage": {
              "type": "object"
            },
            "opacityByPage": {
              "type": "object"
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "rotation": {
              "type": "number"
            },
            "fontSize": {
              "type": "number"
            },
            "color": {
              "description": "Hex string, RGB tuple, or {r,g,b} object."
            },
            "position": {
              "type": "string"
            },
            "perPage": {
              "description": "Object keyed by page number or array of page overrides for text/x/y/opacity."
            },
            "watermarks": {
              "type": "array",
              "description": "Multiple watermark definitions."
            },
            "date": {
              "type": "string"
            }
          }
        }
      },
      {
        "id": "rotate",
        "title": "Rotate Pages",
        "category": "page-operations",
        "description": "Rotate all or selected pages by an angle in degrees.",
        "input_schema": {
          "type": "object",
          "required": [
            "input"
          ],
          "properties": {
            "input": {
              "type": "string",
              "description": "Base64-encoded PDF."
            },
            "args": {
              "type": "object"
            }
          }
        },
        "args_schema": {
          "type": "object",
          "properties": {
            "angle": {
              "type": "number",
              "default": 90
            },
            "pages": {
              "description": "Optional page selector; defaults to all."
            }
          }
        }
      },
      {
        "id": "metadata",
        "title": "PDF Metadata",
        "category": "content-editing",
        "description": "Read, clear, or write document metadata.",
        "input_schema": {
          "type": "object",
          "required": [
            "input"
          ],
          "properties": {
            "input": {
              "type": "string",
              "description": "Base64-encoded PDF."
            },
            "args": {
              "type": "object"
            }
          }
        },
        "args_schema": {
          "type": "object",
          "properties": {
            "clear": {
              "type": "boolean"
            },
            "set": {
              "type": "object",
              "description": "Metadata fields to write."
            }
          }
        }
      }
    ]
  },
  {
    "id": "pii-redact",
    "version": "0.1.0",
    "kind": "operation_pack",
    "runtime": "in_process",
    "format": "native",
    "trust": "trusted",
    "name": "PII Redact",
    "description": "Trusted in-worker structured-PII detector. Regex-scans a parsed node graph (text + bbox) for SSN, EIN, email, phone, credit card, ITIN, IBAN, and IP, and returns redaction boxes to seed the overlay editor. No network egress.",
    "category": "security-redact",
    "publisher": "okrapdf",
    "license": "MIT",
    "capabilities": [],
    "allowed_hosts": [],
    "operations": [
      {
        "id": "detect",
        "title": "Detect Structured PII",
        "category": "security-redact",
        "description": "Regex-scan an already-parsed node graph for structured PII and return redaction boxes (page, x, y, w, h, type, text, score, source) in the box-JSON contract.",
        "input_schema": {
          "type": "object",
          "required": [
            "nodes"
          ],
          "properties": {
            "nodes": {
              "type": "array",
              "description": "Parsed node graph. Each node carries page text and its normalized bbox (top-left origin, fractions of page w/h).",
              "items": {
                "type": "object",
                "required": [
                  "page",
                  "text",
                  "bbox"
                ],
                "properties": {
                  "page": {
                    "type": "number",
                    "description": "1-based page number."
                  },
                  "text": {
                    "type": "string",
                    "description": "Node text to scan."
                  },
                  "bbox": {
                    "type": "object",
                    "required": [
                      "x",
                      "y",
                      "w",
                      "h"
                    ],
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "Left, fraction of page width (0-1)."
                      },
                      "y": {
                        "type": "number",
                        "description": "Top, fraction of page height (0-1)."
                      },
                      "w": {
                        "type": "number",
                        "description": "Width, fraction of page width (0-1)."
                      },
                      "h": {
                        "type": "number",
                        "description": "Height, fraction of page height (0-1)."
                      }
                    }
                  }
                }
              }
            },
            "args": {
              "type": "object",
              "properties": {
                "types": {
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                },
                "minScore": {
                  "type": "number"
                }
              }
            }
          }
        },
        "args_schema": {
          "type": "object",
          "properties": {
            "types": {
              "type": "array",
              "description": "Structured-PII patterns to detect. Omit or empty = all patterns.",
              "items": {
                "type": "string",
                "enum": [
                  "US_SSN",
                  "US_EIN",
                  "EMAIL_ADDRESS",
                  "PHONE_NUMBER",
                  "CREDIT_CARD",
                  "US_ITIN",
                  "IBAN_CODE",
                  "IP_ADDRESS"
                ]
              }
            },
            "minScore": {
              "type": "number",
              "minimum": 0,
              "maximum": 1,
              "description": "Drop boxes below this score. Deterministic regex matches default to 0.99."
            }
          }
        }
      }
    ]
  },
  {
    "id": "presidio-ner",
    "version": "0.1.0",
    "kind": "operation_pack",
    "runtime": "http_base_url",
    "format": "sandboxed",
    "trust": "external",
    "name": "Presidio NER",
    "description": "Detect named-entity PII (person names, locations, orgs, dates) by analyzing a parsed node graph through a BYO Microsoft Presidio analyzer, returning redaction boxes in okra's box-JSON contract. Composes with the native structured-PII detector. Egress bounded to your Presidio host.",
    "category": "security-redact",
    "publisher": "okrapdf",
    "license": "MIT",
    "homepage": "https://microsoft.github.io/presidio/api-docs/api-docs.html",
    "capabilities": [
      "network:fetch"
    ],
    "allowed_hosts": [],
    "allowed_hosts_from": "baseUrl",
    "config_schema": {
      "baseUrl": {
        "type": "string",
        "required": true,
        "secret": false,
        "label": "Presidio analyzer URL",
        "placeholder": "http://localhost:3000"
      }
    },
    "operations": [
      {
        "id": "detect",
        "title": "Detect PII (Presidio NER)",
        "category": "security-redact",
        "description": "POST each node's text to Presidio /analyze and map every entity hit back to its node's bbox, returning redaction boxes (page, x, y, w, h, type, text, score, source) in the box-JSON contract.",
        "input_schema": {
          "type": "object",
          "required": [
            "nodes"
          ],
          "properties": {
            "nodes": {
              "type": "array",
              "description": "Parsed node graph. Each node carries page text and its normalized bbox (top-left origin, fractions of page w/h).",
              "items": {
                "type": "object",
                "required": [
                  "page",
                  "text",
                  "bbox"
                ],
                "properties": {
                  "page": {
                    "type": "number",
                    "description": "1-based page number."
                  },
                  "text": {
                    "type": "string",
                    "description": "Node text to analyze."
                  },
                  "bbox": {
                    "type": "object",
                    "required": [
                      "x",
                      "y",
                      "w",
                      "h"
                    ],
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "Left, fraction of page width (0-1)."
                      },
                      "y": {
                        "type": "number",
                        "description": "Top, fraction of page height (0-1)."
                      },
                      "w": {
                        "type": "number",
                        "description": "Width, fraction of page width (0-1)."
                      },
                      "h": {
                        "type": "number",
                        "description": "Height, fraction of page height (0-1)."
                      }
                    }
                  }
                }
              }
            }
          }
        },
        "args_schema": {
          "type": "object",
          "properties": {
            "types": {
              "type": "array",
              "description": "Presidio entity types to detect (passed as `entities` to /analyze). Omit/empty = let Presidio detect all supported entities.",
              "items": {
                "type": "string",
                "enum": [
                  "PERSON",
                  "LOCATION",
                  "NRP",
                  "ORGANIZATION",
                  "DATE_TIME",
                  "MEDICAL_LICENSE",
                  "US_DRIVER_LICENSE",
                  "US_PASSPORT"
                ]
              }
            },
            "minScore": {
              "type": "number",
              "minimum": 0,
              "maximum": 1,
              "description": "Drop entity hits whose Presidio confidence score is below this. Default 0."
            }
          },
          "required": []
        }
      }
    ],
    "adapter": {
      "type": "http_base_url",
      "base_url_from": "baseUrl",
      "operations": [
        {
          "id": "detect",
          "title": "Presidio Analyze",
          "category": "security-redact",
          "description": "Per-node POST to Presidio /analyze (JSON). Handled by presidio-ner-driver, not the multipart driver.",
          "method": "POST",
          "path": "/analyze",
          "request": "multipart/form-data",
          "fields": [],
          "response": "application/json"
        }
      ]
    }
  },
  {
    "id": "qwen3-vl-openrouter",
    "version": "0.1.0",
    "kind": "parser",
    "runtime": "openai_compatible",
    "format": "sandboxed",
    "trust": "external",
    "name": "Qwen3-VL · OpenRouter",
    "description": "OpenRouter preset for qwen/qwen3-vl-235b-a22b-instruct using native PDF mode. Good for model-native PDF understanding, but may fail or return sparse text on pure scans because okra-solo does not rasterize pages before calling the model.",
    "catalog": {
      "name": "Qwen3-VL",
      "one_liner": "OpenRouter-backed Qwen locator preset for bbox grounding and visual evidence checks."
    },
    "category": "parse-extract",
    "tags": [
      "ocr",
      "vlm"
    ],
    "publisher": "openrouter",
    "license": "proprietary",
    "homepage": "https://openrouter.ai/docs/guides/overview/multimodal/pdfs",
    "capabilities": [
      "network:fetch"
    ],
    "allowed_hosts": [
      "openrouter.ai"
    ],
    "config_schema": {
      "apiKey": {
        "type": "string",
        "secret": true,
        "required": true,
        "label": "OpenRouter API key",
        "placeholder": "sk-or-..."
      }
    },
    "adapter": {
      "type": "openai_compatible",
      "base_url": "https://openrouter.ai/api/v1",
      "model": "qwen/qwen3-vl-235b-a22b-instruct",
      "openrouter_pdf_mode": "native"
    }
  },
  {
    "id": "stirling-pdf",
    "version": "0.1.0",
    "kind": "operation_pack",
    "runtime": "http_base_url",
    "format": "sandboxed",
    "trust": "external",
    "name": "Stirling-PDF",
    "description": "Wrap a self-hosted Stirling-PDF base URL as deterministic PDF operations under okra's allowed-host egress envelope.",
    "category": "page-operations",
    "publisher": "okrapdf",
    "license": "MIT",
    "homepage": "https://docs.stirlingpdf.com/API/",
    "capabilities": [
      "network:fetch",
      "pdf:merge",
      "pdf:stamp"
    ],
    "allowed_hosts": [],
    "allowed_hosts_from": "baseUrl",
    "config_schema": {
      "baseUrl": {
        "type": "string",
        "required": true,
        "label": "Stirling-PDF base URL",
        "placeholder": "http://stirling-pdf:8080"
      },
      "apiKey": {
        "type": "string",
        "secret": true,
        "required": false,
        "label": "Stirling X-API-KEY",
        "placeholder": "Only needed when SECURITY_ENABLELOGIN=true"
      }
    },
    "adapter": {
      "type": "http_base_url",
      "base_url_from": "baseUrl",
      "auth": {
        "header": "X-API-KEY",
        "value_from": "apiKey",
        "optional": true
      },
      "operations": [
        {
          "id": "merge",
          "aliases": [
            "merge_pdfs"
          ],
          "title": "Stirling Merge PDFs",
          "category": "page-operations",
          "description": "Call Stirling /api/v1/general/merge-pdfs with repeated fileInput fields.",
          "method": "POST",
          "path": "/api/v1/general/merge-pdfs",
          "request": "multipart/form-data",
          "fields": [
            {
              "name": "fileInput",
              "type": "file[]",
              "required": true
            },
            {
              "name": "sortType",
              "type": "string",
              "default": "orderProvided"
            },
            {
              "name": "removeCertSign",
              "type": "boolean",
              "default": false
            },
            {
              "name": "generateToc",
              "type": "boolean",
              "default": false
            }
          ],
          "response": "application/pdf"
        },
        {
          "id": "stamp",
          "aliases": [
            "add_stamp"
          ],
          "title": "Stirling Add Stamp",
          "category": "content-editing",
          "description": "Call Stirling /api/v1/misc/add-stamp for text stamping.",
          "method": "POST",
          "path": "/api/v1/misc/add-stamp",
          "request": "multipart/form-data",
          "fields": [
            {
              "name": "fileInput",
              "type": "file",
              "required": true
            },
            {
              "name": "pageNumbers",
              "type": "string",
              "default": "all",
              "aliases": [
                "pages"
              ]
            },
            {
              "name": "stampType",
              "type": "string",
              "default": "text"
            },
            {
              "name": "stampText",
              "type": "string",
              "required": true,
              "aliases": [
                "text",
                "template"
              ]
            },
            {
              "name": "alphabet",
              "type": "string",
              "default": "roman"
            },
            {
              "name": "fontSize",
              "type": "number",
              "default": 16,
              "aliases": [
                "size"
              ]
            },
            {
              "name": "rotation",
              "type": "number",
              "default": 0
            },
            {
              "name": "opacity",
              "type": "number",
              "default": 0.65
            },
            {
              "name": "position",
              "type": "number",
              "default": 9
            },
            {
              "name": "overrideX",
              "type": "number",
              "default": -1,
              "aliases": [
                "x"
              ]
            },
            {
              "name": "overrideY",
              "type": "number",
              "default": -1,
              "aliases": [
                "y"
              ]
            },
            {
              "name": "customMargin",
              "type": "string",
              "default": "small"
            },
            {
              "name": "customColor",
              "type": "string",
              "default": "#1F7A4C",
              "aliases": [
                "color"
              ]
            }
          ],
          "response": "application/pdf"
        }
      ]
    }
  },
  {
    "id": "text-layer",
    "version": "0.1.0",
    "kind": "parser",
    "runtime": "openai_compatible",
    "format": "sandboxed",
    "trust": "external",
    "name": "Text Layer (free)",
    "description": "OpenRouter preset using PDF text-layer extraction mode. Free for text-bearing PDFs, but it does not OCR scanned or image-only pages and may return little or no text for those files. Bring your own OpenRouter API key; egress is pinned to openrouter.ai.",
    "category": "parse-extract",
    "tags": [
      "text"
    ],
    "publisher": "openrouter",
    "license": "proprietary",
    "homepage": "https://openrouter.ai/docs/guides/overview/multimodal/pdfs",
    "capabilities": [
      "network:fetch"
    ],
    "allowed_hosts": [
      "openrouter.ai"
    ],
    "config_schema": {
      "apiKey": {
        "type": "string",
        "secret": true,
        "required": true,
        "label": "OpenRouter API key",
        "placeholder": "sk-or-..."
      }
    },
    "adapter": {
      "type": "openai_compatible",
      "base_url": "https://openrouter.ai/api/v1",
      "model": "qwen/qwen3-vl-235b-a22b-instruct",
      "openrouter_pdf_mode": "pdf-text"
    }
  }
] as const satisfies readonly CatalogPluginDescriptor[];
